module.exports = __webpack_public_path__ + "static/ActaHeadline-Book-bdcc3ced98da745c69d73740a23efb0e.woff";